import { objectIsEmpty, filterTableForCurrentAmount } from './utils';

// TODO - TRADURRE: Troviamo tra tutti gli oggetti con importo x quello con numero di rate minore (il tutto dipendente dalla minRata)
const getElementWithMinNumberOfInstallments = (data) => {
  const { table, currentAmount, currentPayment } = data;
  const roundedAmount = Math.round(currentAmount / 1000) * 1000;
  const tableRowsWithCurrentAmount = filterTableForCurrentAmount(table, roundedAmount);

  const elementInfo = tableRowsWithCurrentAmount.reduce((accumulator, currentRow, index) => {
    // se non esistesse una riga con minRata <= alla rata corrente ci sono solo 2 spiegazioni: o lo slider è rotto o le tabelle contengono valori non corretti
    if (parseFloat(currentRow["minRata"].replace(",", ".")) <= parseFloat(accumulator["currentPayment"])) {
      if (accumulator["index"] < 0 || parseFloat(currentRow["NumRate"]) < parseFloat(accumulator["row"]["NumRate"])) {
        return {
          ...accumulator,
          row: currentRow,
          index,
        };
      }

      return accumulator;
    }
    
    return accumulator;
  }, {
    row: null,
    index: -1,
    currentPayment
  });

  return {
    row: elementInfo["row"],
    index: elementInfo["index"]
  }
}

// TODO - TRADURRE: Troviamo tra tutti gli oggetti con importo x quello con numero di rate minore (il tutto dipendente dalla maxRata)
const getElementWithMaxNumberOfInstallments = (data) => {
  const { table, currentAmount, currentPayment } = data;
  const roundedAmount = Math.round(currentAmount / 1000) * 1000;
  const tableRowsWithCurrentAmount = filterTableForCurrentAmount(table, roundedAmount);

  const elementInfo = tableRowsWithCurrentAmount.reduce((accumulator, currentRow, index) => {
    // se non esistesse una riga con minRata <= alla rata corrente ci sono solo 2 spiegazioni: o lo slider è rotto o le tabelle contengono valori non corretti
    if (parseFloat(currentRow["maxRata"].replace(",", ".")) <= parseFloat(accumulator["currentPayment"])) {
      if (accumulator["index"] < 0 || parseFloat(currentRow["NumRate"]) < parseFloat(accumulator["row"]["NumRate"])) {
        return {
          ...accumulator,
          row: currentRow,
          index,
        };
      }

      return accumulator;
    }
    
    return accumulator;
  }, {
    row: null,
    index: -1,
    currentPayment
  });

  return {
    row: elementInfo["row"],
    index: elementInfo["index"]
  }
}


const getMinRata = (row) => {
  return parseFloat(row["minRata"].replace(",", "."));
}

const getMaxRata = (row) => {
  return parseFloat(row["maxRata"].replace(",", "."));
}

const getMinTAEG = (rowWithMinNumberOfInstallments) => {
  return parseFloat(rowWithMinNumberOfInstallments["minTAEG"].replace(",", "."));
}

const getMaxTAEG = (rowWithMaxNumberOfInstallments) => {
  return parseFloat(rowWithMaxNumberOfInstallments["maxTAEG"].replace(",", "."));
}

const getMinTAN = (rowWithMinNumberOfInstallments) => {
  return parseFloat(rowWithMinNumberOfInstallments["minTAN"].replace(",", "."));
}

const getMaxTAN = (rowWithMaxNumberOfInstallments) => {
  return parseFloat(rowWithMaxNumberOfInstallments["maxTAN"].replace(",", "."));
}

export const updateCurrentSimulation = function(data, callbacks) {
  const { table, logarithmicCurrentAmount: currentAmount, logarithmicCurrentPayment: currentPayment, frontLayer } = data;
  const { setCurrentSimulation } = callbacks;

  let rowWithMinNumberOfInstallments;
  let rowWithMaxNumberOfInstallments;
  let realCurrentPayment;

  
  if (!objectIsEmpty(frontLayer)) {
    rowWithMinNumberOfInstallments = getElementWithMinNumberOfInstallments(
      {
        table,
        currentAmount,
        currentPayment: frontLayer.currentValue
      },
    );
  
    rowWithMaxNumberOfInstallments = getElementWithMaxNumberOfInstallments(
      {
        table,
        currentAmount,
        currentPayment: frontLayer.currentValue
      },
    );

    realCurrentPayment = frontLayer.currentValue;
  } else {
    rowWithMinNumberOfInstallments = getElementWithMinNumberOfInstallments(
      {
        table,
        currentAmount,
        currentPayment
      },
    );
  
    rowWithMaxNumberOfInstallments = getElementWithMaxNumberOfInstallments(
      {
        table,
        currentAmount,
        currentPayment,
      },
    );

    realCurrentPayment = currentPayment;
  }

  if (!rowWithMaxNumberOfInstallments["row"]) {
    console.log(rowWithMaxNumberOfInstallments);
    return;
  }

  if (
    !rowWithMaxNumberOfInstallments["row"]
    && !rowWithMinNumberOfInstallments["row"]
  ) {
    //console.log('value out of range of the table');
    return;
  }

  setCurrentSimulation({
    amount: {
      current: currentAmount,
      min: rowWithMinNumberOfInstallments["row"]["minDovuto"],
      max: rowWithMaxNumberOfInstallments["row"]["maxDovuto"],
    },
    payment: {
      current: realCurrentPayment,
      min: rowWithMinNumberOfInstallments["row"]["minRata"],
      max: rowWithMaxNumberOfInstallments["row"]["maxRata"],
    },
    numberOfInstallments: {
      min: rowWithMinNumberOfInstallments["row"]["NumRate"],
      max: rowWithMaxNumberOfInstallments["row"]["NumRate"],
    },
    TAN: {
      min: getMinTAN(rowWithMinNumberOfInstallments["row"]),
      max: getMaxTAN(rowWithMaxNumberOfInstallments["row"]),
    },
    TAEG: {
      min: getMinTAEG(rowWithMinNumberOfInstallments["row"]),
      max: getMaxTAEG(rowWithMaxNumberOfInstallments["row"]),
    },
    others: {
      transparencyDuty: rowWithMinNumberOfInstallments["row"]["impTrasparenza"],
      administrationFees: rowWithMinNumberOfInstallments["row"]["comm"],
      administrationFeesMax: rowWithMinNumberOfInstallments["row"]["maxCommissioni"],
      stampDuty: rowWithMinNumberOfInstallments["row"]["impBollo"],
      stampDutyMax: rowWithMinNumberOfInstallments["row"]["maxImpBollo"],
    }
  });
}

export const initFirstSimulation = async function(data, callbacks, setNewSimulationData = true) {
  const { table, logarithmicCurrentAmount: currentAmount, skipSimulation = false } = data;
  const { setCurrentSimulation, setPaymentSlider } = callbacks;

  //If skipSimulation = true, method not used
  if(!skipSimulation) {
    const tableFiltered = filterTableForCurrentAmount(table, currentAmount);
    
    const minRataRows = tableFiltered.map(row => { return getMinRata(row); }),
      maxRataRows = tableFiltered.map(row => { return getMaxRata(row); });
  
    let rowWithMinNumberOfInstallments = null,
      rowWithMaxNumberOfInstallments = null;
  
    //TODO: insteado of 5 use step from payment slider;
    const minPayment = Math.ceil(Math.min(...maxRataRows) / 5) * 5,
      maxPayment = Math.ceil(Math.max(...maxRataRows) / 5) * 5;
  
    rowWithMinNumberOfInstallments = getElementWithMinNumberOfInstallments(
      {
        table,
        currentAmount,
        currentPayment: minPayment
      },
    );
  
    rowWithMaxNumberOfInstallments = getElementWithMaxNumberOfInstallments(
      {
        table,
        currentAmount,
        currentPayment: minPayment
      },
    );
  
    if (!rowWithMaxNumberOfInstallments["row"]) {
      console.log(rowWithMaxNumberOfInstallments);
      return;
    }
  
    if (
      !rowWithMaxNumberOfInstallments["row"]
      && !rowWithMinNumberOfInstallments["row"]
    ) {
      //console.log('value out of range of the table');
      return;
    }
  
    if(
      setNewSimulationData
    ) {
      await setPaymentSlider({
        currentValue: {
            real: minPayment,
            shown: minPayment
        },
        min: minPayment,
        max: maxPayment,
        reinitialize: true
      });
  
    
      await setCurrentSimulation({
        amount: {
            current: currentAmount,
            min: rowWithMinNumberOfInstallments["row"]["minDovuto"],
            max: rowWithMaxNumberOfInstallments["row"]["maxDovuto"],
        },
        payment: {
            current: minPayment,
            min: rowWithMinNumberOfInstallments["row"]["minRata"],
            max: rowWithMaxNumberOfInstallments["row"]["maxRata"],
        },
        numberOfInstallments: {
            min: rowWithMinNumberOfInstallments["row"]["NumRate"],
            max: rowWithMaxNumberOfInstallments["row"]["NumRate"],
        },
        TAN: {
            min: getMinTAN(rowWithMinNumberOfInstallments["row"]),
            max: getMaxTAN(rowWithMaxNumberOfInstallments["row"]),
        },
        TAEG: {
            min: getMinTAEG(rowWithMinNumberOfInstallments["row"]),
            max: getMaxTAEG(rowWithMaxNumberOfInstallments["row"]),
        },
        others: {
            transparencyDuty: rowWithMinNumberOfInstallments["row"]["impTrasparenza"],
            administrationFees: rowWithMinNumberOfInstallments["row"]["comm"],
            administrationFeesMax: rowWithMinNumberOfInstallments["row"]["maxCommissioni"],
            stampDuty: rowWithMinNumberOfInstallments["row"]["impBollo"],
            stampDutyMax: rowWithMinNumberOfInstallments["row"]["maxImpBollo"],
        }
      });
    }
  }

}